import { onFormatClick } from '../../js/format-utils';
import {
  sendAnalyticsTrack,
  sendCreativeClientIgnoredClick
} from '../../js/TrackAnalyticsHelper';
import { triggerOgyOnAdClicked } from '../../js/mraid-utils';
import { preventSpamCallsShared } from '../../js/utils';
import { AnalyticsStore } from '../AnalyticsStore';
import { MraidStore } from '../MraidStore';
import { UITimerStore } from '../UITimerStore';
import { action, makeObservable, observable } from 'mobx';

export interface UserClickHandlerProps {
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
  uiTimerStore: UITimerStore;
  formatConfig: any;
  formatOptions: FormatOptions;
  formatContext: AdContext;
  formatName?: string;
}
export class UserClickHandler {
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
  uiTimerStore: UITimerStore;
  formatConfig: any;
  formatOptions: FormatOptions;
  formatContext: AdContext;
  formatName: string;

  hasClicked: boolean = false;

  constructor({
    analyticsStore,
    mraidStore,
    uiTimerStore,
    formatConfig,
    formatOptions,
    formatContext,
    formatName = ''
  }: UserClickHandlerProps) {
    this.analyticsStore = analyticsStore;
    this.mraidStore = mraidStore;
    this.uiTimerStore = uiTimerStore;
    this.formatConfig = formatConfig;
    this.formatOptions = formatOptions;
    this.formatContext = formatContext;
    this.formatName = formatName;
    this.handle = preventSpamCallsShared(this.handle.bind(this));

    makeObservable<UserClickHandler, 'setUserHasClicked' | 'hasClicked'>(this, {
      hasClicked: observable,
      setUserHasClicked: action
    });
  }

  handle(e: ClickEvent) {
    sendAnalyticsTrack(e, 'format_interaction', true);
    this.analyticsStore.sendCreativeTrack('client_click', e);
    if (this.mraidStore.isViewable) {
      this.analyticsStore.sendCreativeTrack('viewable');
    }
    triggerOgyOnAdClicked();
    this.setUserHasClicked();
    onFormatClick(this.formatOptions, this.formatConfig.clickUrl);
  }

  handleCreativeIgnoredClick(e: ClickEvent) {
    sendCreativeClientIgnoredClick(e);
  }

  protected setUserHasClicked() {
    this.hasClicked = true;
  }
}
